const config = {
    //backendDomain: `${window.location.protocol}//demo10.wsteam.com.ru:3072`
    backendDomain: `https://demo10.wsteam.com.ru:3072`
};

export default config;